<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from 'vuex';
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Audit Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Audit Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Audits",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "user",
          label: "User",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Date",
          sortable: true,
        },
      ],
      data: {
        from: "",
        to: moment(new Date()).format("YYYY-MM-DD"),
      },
    };
  },
  computed: {
       ...mapGetters("fees", ["Audit", "SaveStatus"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Audit?this.Audit.length:1;
    },

  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Audit?this.Audit.length:1;
  },
  methods: {
     ...mapActions({
      FetchAudits: "audits/fetchAudits",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Audit?this.Audit.length:1;
      this.currentPage = 1;
    },
    Fetch_Receipts(){
      if(this.data.from ==""){
        this.fromError = "Please choose start date";
        return
      }
      else{
        this.fromError = "";
      }
      this.FetchAudits(this.data);
    },
  },
  created() {
    this.FetchAudits(this.data);
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                      <label class="col-form-label">From <span class="required">*</span></label>
                      <input type="date" class="form-control" v-model="data.from">
                      <div v-if="fromError" class="text-danger">
                        <em>{{fromError}}</em>
                      </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="col-form-label"> To <span class="required">*</span></label>
                    <input type="date" class="form-control" v-model="data.to">
                </div>
                </div>
                <div class="col-md-3 mt-3"><br>
                  <button @click="Fetch_Receipts()" class="btn btn-primary"><i class="fa fa-search"></i> Search</button>
                </div>
                <div class="col-md-3"></div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Audit ? Audit : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>
